import { render, staticRenderFns } from "./DiedrickBrackens.vue?vue&type=template&id=f5b4a154&"
import script from "./DiedrickBrackens.vue?vue&type=script&lang=js&"
export * from "./DiedrickBrackens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports